import {BeautifulMentionsMenuItemProps} from 'lexical-beautiful-mentions';
import {HStack} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {useContext} from 'react';

import {isNotNil} from 'ramda';

import {StatusIndicatorDot} from '../../Choice/utils/StatusIndicatorDot';
import {MenuItemStatusIndicatorContext} from './MenuItemStatusIndicatorContext';

export const StyledMenuItem = styled.li<{
  $isSelected?: boolean;
}>`
  list-style-type: none;
  padding: 8px;
  border-radius: ${({theme}) => theme.radii.small};
  font-size: ${({theme}) => theme.fontSizes.text.small};

  ${({$isSelected}) =>
    $isSelected &&
    css`
      background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
      color: ${({theme}) => theme.colors.palettes.blue[80][100]};
    `}
`;

interface CustomMenuItemProps extends BeautifulMentionsMenuItemProps {
  ref?: React.Ref<HTMLLIElement>;
}

export function CustomMenuItem({selected, ref, item, children, ...props}: CustomMenuItemProps) {
  const statusIndicatorById = useContext(MenuItemStatusIndicatorContext);

  const itemId = item?.data?.id;
  const statusIndicator = typeof itemId === 'string' ? statusIndicatorById.get(itemId) : undefined;

  return (
    <StyledMenuItem {...props} ref={ref} $isSelected={selected}>
      {isNotNil(statusIndicator) ? (
        <HStack align="center" spacing={1}>
          {children}
          <StatusIndicatorDot statusIndicator={statusIndicator} />
        </HStack>
      ) : (
        children
      )}
    </StyledMenuItem>
  );
}
